export class TimePeriod {

  id: number;
  name: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  startTime: string;
  endTime: string;

  public constructor(init?: Partial<TimePeriod>) {
    Object.assign(this, init);
  }
}
